import React from "react";
import AlertComponent from "@mui/material/Alert";
import { Alert } from "hooks/use-alert-bar.hook";

interface CustomAlertProps {
  alert: Alert;
  onClose: (id: number | string) => void;
}

export default function CustomAlert({ alert, onClose }: CustomAlertProps) {
  return (
    <AlertComponent
      variant="filled"
      severity={alert.severity}
      onClose={() => onClose(alert.id)}
    >
      {alert.message}
    </AlertComponent>
  );
}
